// Report structure field names - used across all SROI graph helpers

// Top-level report fields
export const CATEGORICAL_IMPACT = 'categorical_impact'
export const REGIONAL_IMPACT = 'regional_impact'

// Impact type fields
export const GENDER_IMPACT = 'gender_impact'
export const AGE_IMPACT = 'age_impact'
export const ETHNICITY_IMPACT = 'ethnicity_impact'
export const DISABILITY_IMPACT = 'disability_impact'
export const IMD_IMPACT = 'imd_impact'

// Stakeholder/categorical fields
export const STAKEHOLDER_TYPE = 'stakeholder_type'
export const SPORTS_TYPE = 'sports_type'
export const STAKEHOLDER_COUNT = 'stakeholder_count'
export const IMPACT_PER_STAKEHOLDER = 'impact_per_stakeholder'
export const ACTIVITY_HOURS = 'activity_hours'

// Regional fields
export const REGION_NAME = 'region'

// Impact pathway fields
export const HEALTH_IMPACT = 'health_impact'
export const WELLBEING_IMPACT = 'wellbeing_impact'
export const INDIRECT_FINANCIAL_HEALTH_IMPACT = 'indirect_financial_health_impact'
export const INDIRECT_FINANCIAL_HUMAN_CAPITAL_IMPACT = 'indirect_financial_human_capital_impact'
export const TOTAL_IMPACT = 'total_impact'

// Theme attribution
export const THEME_ATTRIBUTION = 'theme_attribution'

// Capital impact
export const CAPITAL_IMPACT = 'capital_impact'
